import { useNavigate } from "react-router-dom";

import { DidYouKnowScreen } from "../components/DidYouKnowScreen";
import { usePersonalisationData } from "../context/PersonalisationDataContext";

import { PreparingScreenContainer_PATH } from "./PreparingScreenContainer";

// NOTE: No longer used as of oct 14 2025. Kept here just in case.
export const DidYouKnowContainer_PATH = "/personalise/did-you-know" as const;

export function DidYouKnowContainer() {
  const navigate = useNavigate();
  const { advisorIdentity } = usePersonalisationData();

  return (
    <DidYouKnowScreen
      onNext={() => navigate(PreparingScreenContainer_PATH)}
      adonisIdentity={advisorIdentity}
    />
  );
}
